module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry_tablet-2c3dfc0d1937b4e40575aba0788e328e.png";